<template>
    <div>
        <div>
            <Table :columns="tblColumns" :data="tblData" size="small" :loading="isLoading" class="attendanceTable" />
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { getRequestRecordById } from '@/services/requests.services';
export default {
    props: {
        requestId: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            isLoading: false,
            tblColumns: [
                {
                    title: 'Start',
                    key: 'clockInTime',
                    width: 200,
                    render: (h, params) => {
                        return params.row.currentData.clockInTime && params.row.currentData.totalDailyHrs
                            ? h('div', moment(params.row.currentData.clockInTime).utc().format('hh:mm A'))
                            : h('div', { class: 'hyphenFont' }, '-');
                    },
                },
                {
                    title: 'End',
                    key: 'clockOutTime',
                    width: 200,
                    render: (h, params) => {
                        return params.row.currentData.clockOutTime && params.row.currentData.totalDailyHrs
                            ? h('div', moment(params.row.currentData.clockOutTime).utc().format('hh:mm A'))
                            : h('div', { class: 'hyphenFont' }, '-');
                    },
                },
                {
                    title: 'Total Hours',
                    key: 'totalDailyHrs',
                    width: 150,
                    render: (h, params) => {
                        return params.row.currentData.totalDailyHrs
                            ? h('div', Number(params.row.currentData.totalDailyHrs).toFixed(0))
                            : h('div', { class: 'hyphenFont' }, '-');
                    },
                },
            ],
            tblData: [],
        };
    },

    watch: {
        requestId(data) {
            this.populateRequestTimeDisputes(data);
        },
    },

    created() {
        this.populateRequestTimeDisputes(this.requestId);
    },

    methods: {
        async populateRequestTimeDisputes(id) {
            this.isLoading = true;
            this.tblData = [];
            getRequestRecordById(id)
                .then((res) => {
                    this.tblData = [res.data];
                    this.isLoading = false;
                })
                .catch(() => {
                    this.$Message.error('Failed to get requested time logs');
                    this.isLoading = false;
                    this.tblData = [];
                });
        },
    },
};
</script>

<style lang="scss">
ul.pagination.ivu-page {
    text-align: end;
}
.attendanceTable i.ivu-icon {
    margin-left: -12.5px;
}
</style>
